@if (!hideIcon()) {
  <div class="mui-dropzone__icon">
    <mui-icon [font]="iconFont()" [name]="icon()"/>
  </div>
}
@if (label(); as label) {
  <div class="mui-dropzone__label" [id]="labelId">{{ label }}</div>
}
<ng-content/>
